/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/function-component-definition */
import React from 'react';
import DataTable, { TableProps } from 'react-data-table-component';

import Lottie from 'lottie-react';

import { ReactComponent as SortIcon } from 'src/assets/table-sort-icon.svg';
import loadingAnimation from 'src/assets/loading-animation.json';
import './styles.css';

export function DefaultTable<T>(props: TableProps<T>): JSX.Element {
  const customStyles = {
    headRow: {
      style: {
        border: 'none',
      },
    },
    headCells: {
      style: {
        color: '#9399B2',
        font: 'normal normal bold 16px Biotif',
      },
    },
    rows: {
      style: {
        font: 'normal normal normal 14px Biotif',
        color: '#1B1D35',
        borderRadius: '5px',
        '&:not(:last-of-type)': {
          borderBottomWidth: '0px',
        },
      },
      stripedStyle: {
        color: '#1B1D35',
        backgroundColor: '#F3F4F8',
      },
      highlightOnHoverStyle: {
        backgroundColor: 'rgb(230, 244, 244)',
        borderBottomColor: '#FFFFFF',
        borderRadius: '25px',
        outline: '1px solid #FFFFFF',
      },
    },
    pagination: {
      style: {
        border: 'none',
        svg: {
          fill: 'rgba(0,0,0,0.54)',
        },
      },
    },
  };

  return (
    <DataTable
      progressComponent={
        <div
          style={{
            padding: '24px',
            position: 'relative',
            width: '250px',
            height: '250px',
          }}
        >
          <Lottie animationData={loadingAnimation} />
        </div>
      }
      sortIcon={<SortIcon />}
      customStyles={customStyles}
      pointerOnHover
      pagination
      striped
      dense
      noHeader
      {...props}
    />
  );
}
